<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="19.501" height="19.876" viewBox="0 0 19.501 19.876">
        <path
            id="Path_161"
            data-name="Path 161"
            d="M43.494,26v3.75a.75.75,0,0,1-.75.75,9.675,9.675,0,0,1-4.5-1.1V32.75a7.125,7.125,0,1,1-8.381-7.012.75.75,0,0,1,.609.159.731.731,0,0,1,.272.581v3.9a.741.741,0,0,1-.431.675,1.875,1.875,0,1,0,2.681,1.7v-12a.75.75,0,0,1,.75-.75h3.75a.75.75,0,0,1,.75.75,4.5,4.5,0,0,0,4.5,4.5A.75.75,0,0,1,43.494,26Z"
            transform="translate(-23.994 -20)" />
    </svg>
</template>
